/**
 * The transfer-tax + savings calculator on /en/sell-by-owner/{state}. The server already
 * printed a full example (src/fsbo/fsbo.ts), so this only recomputes it from the typed
 * price. Rate comes from the section's data-rate ("" = not a flat number, 0 = no tax).
 */
import { parsePrice, savings, usd, usdRange } from './calc.js';

const root = document.querySelector<HTMLElement>('.fsbo-calc');
const input = root?.querySelector<HTMLInputElement>('#calc-price');
if (root && input) {
  const raw = root.dataset.rate ?? '';
  const rate = raw === '' ? null : Number(raw);
  const out = (k: string) => root.querySelector<HTMLElement>(`[data-out="${k}"]`);
  const caption = out('caption');
  const captionTail = caption?.textContent?.replace(/^Example for a [^.]+ sale\.\s*/, '') ?? '';

  const update = () => {
    const price = parsePrice(input.value);
    if (!Number.isFinite(price) || price <= 0) {
      input.setAttribute('aria-invalid', 'true');
      return;
    }
    input.removeAttribute('aria-invalid');
    const s = savings(price, rate, rate === 0 ? false : null);
    const tax = out('tax');
    if (tax && s.transferTax !== null) tax.textContent = usd(s.transferTax);
    const com = out('commission');
    if (com) com.textContent = usdRange(s.commissionLow, s.commissionHigh);
    const lst = out('listing');
    if (lst) lst.textContent = usdRange(s.listingSideLow, s.listingSideHigh);
    if (caption) caption.textContent = `For a sale price of ${usd(s.price)}. ${captionTail}`;
  };

  input.addEventListener('input', update);
  input.addEventListener('blur', () => {
    const p = parsePrice(input.value);
    if (Number.isFinite(p) && p > 0) input.value = usd(p);
  });
}
